import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb313e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "image"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "placeholder bg-primary col-12" })
], -1))
const _hoisted_3 = {
  key: 1,
  class: "image-banner-slot"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "title"
}
const _hoisted_6 = {
  key: 3,
  class: "link"
}
const _hoisted_7 = {
  key: 4,
  class: "category"
}
const _hoisted_8 = {
  key: 5,
  class: "short-content"
}
const _hoisted_9 = {
  key: 6,
  class: "sort-weight"
}
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "visibility", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "image d-flex justify-content-center mb-3"
}
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 1,
  class: "content"
}
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      (['BANNER', 'BANNER_IN_SLOT', 'IMAGE', 'TEXT_WITH_IMAGE'].includes(_ctx.contentType))
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            (this.contentBlock.image_key)
              ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                  fallback: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_LazyImage, {
                      "image-key": this.contentBlock.image_key,
                      alt: "Overview image"
                    }, null, 8, ["image-key"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ((_ctx.contentType === 'BANNER_SLOT'))
        ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
            (this.contentBlock.image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: this.contentBlock.image_url,
                  class: "border border-1 shadow-sm",
                  alt: "Overview image"
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (['TEXT_WITH_TITLE', 'TEXT_WITH_IMAGE', 'IMAGE', 'BANNER_SLOT'].includes(_ctx.contentType))
        ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.contentBlock.title ? _ctx.contentBlock.title : ''), 1))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'BANNER')
        ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.contentBlock.title ? _ctx.contentBlock.title : '/'), 1))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'BANNER')
        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.contentBlock.category ? _ctx.contentBlock.category : ''), 1))
        : _createCommentVNode("", true),
      (['BANNER', 'BANNER_IN_SLOT', 'TEXT_WITH_TITLE', 'TEXT_WITH_IMAGE'].includes(_ctx.contentType))
        ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.strippedShortContent), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.contentType !== 'BANNER_SLOT')
        ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.contentBlock.sort_weight ? _ctx.contentBlock.sort_weight : ''), 1))
        : _createCommentVNode("", true),
      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.contentBlock.status.description ? _ctx.contentBlock.status.description : '/'), 1),
      _createElementVNode("td", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.canPreview)
            ? (_openBlock(), _createBlock(_component_base_modal_button, {
                key: 0,
                "modal-id": _ctx.previewModalId,
                class: "btn btn-icon btn-outline-primary ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["modal-id"]))
            : _createCommentVNode("", true),
          (_ctx.canUseModal)
            ? (_openBlock(), _createBlock(_component_base_modal_button, {
                key: 1,
                "modal-id": _ctx.modalId,
                class: "btn btn-icon btn-primary ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["modal-id"]))
            : (_ctx.routeObjectEditCb)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: _ctx.dynamicRouteObjectEditCb(_ctx.contentBlock.id),
                  class: "btn btn-icon btn-primary ms-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
          (_ctx.contentType !== 'BANNER_SLOT')
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteContentBlock(_ctx.contentBlock.id))),
                class: "btn btn-icon btn-danger ms-2"
              }, _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.canPreview)
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 0,
          "modal-id": _ctx.previewModalId,
          "no-footer": ""
        }, {
          default: _withCtx(() => [
            (['BANNER', 'IMAGE', 'TEXT_WITH_IMAGE'].includes(_ctx.contentType))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.contentBlock.url && _ctx.contentBlock.image_key)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: _ctx.contentBlock.url,
                          alt: _ctx.contentBlock.image_key,
                          class: "img-fluid"
                        }, null, 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (['TEXT_WITH_IMAGE', 'TEXT_WITH_TITLE'].includes(_ctx.contentType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.contentBlock.title ? _ctx.contentBlock.title : ''), 1),
                  _createElementVNode("div", {
                    innerHTML: _ctx.contentBlock.short_content,
                    class: "content"
                  }, null, 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modal-id"]))
      : _createCommentVNode("", true)
  ], 64))
}